import { render, staticRenderFns } from "./ShopFooterSections.vue?vue&type=template&id=a2546634&scoped=true&"
import script from "./ShopFooterSections.vue?vue&type=script&lang=js&"
export * from "./ShopFooterSections.vue?vue&type=script&lang=js&"
import style0 from "./ShopFooterSections.vue?vue&type=style&index=0&id=a2546634&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2546634",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewsGrid: require('/opt/build/repo/apps/shop/components/storyblok/ReviewsGrid/ReviewsGrid.vue').default,FaqsCollapsibleContainer: require('/opt/build/repo/apps/shop/components/storyblok/FaqsCollapsibleContainer/FaqsCollapsibleContainer.vue').default})
